module.exports = __webpack_public_path__ + "media/make8.0ef35a97.mp4";